import React, { useState } from "react";
import "./App.css";
import ChatPanel from "./components/ChatPanel";
import ResultsPanel from "./components/ResultsPanel";
import SqlConsole from "./components/SqlConsole";
import TeamPage from "./components/TeamPage";
import { useTranslation } from "./LanguageContext";
import SharedView from "./components/SharedView";

const ADMIN_PATH = "/admin/d8f3a291";
const ROOT_HOST = "results.nyrr.run";

function getTeamSlug() {
  const host = window.location.hostname;
  if (host === ROOT_HOST || host === "localhost") return null;
  const sub = host.replace(`.${ROOT_HOST}`, "");
  return sub !== host ? sub : null;
}

export default function App() {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("chat");
  const { lang, t, toggleLang } = useTranslation();

  if (window.location.pathname === ADMIN_PATH) {
    return <SqlConsole />;
  }

  if (window.location.pathname.startsWith("/share/")) {
    const shareId = window.location.pathname.slice("/share/".length);
    return <SharedView shareId={shareId} />;
  }

  const teamSlug = getTeamSlug();
  if (teamSlug) {
    return <TeamPage slug={teamSlug} />;
  }

  const handleResult = (r) => {
    setResult(r);
  };

  const resultCount = result && result.rows && result.rows.length > 0 ? result.rows.length : 0;

  return (
    <div className="app-shell">
      <header className="app-header">
        <span className="app-logo">NYRR Head to Head</span>
        <div className="app-header-right">
          <nav className="app-tabs">
            <button
              className={`app-tab${activeTab === "chat" ? " app-tab--active" : ""}`}
              onClick={() => setActiveTab("chat")}
            >
              {t.chat}
            </button>
            <button
              className={`app-tab${activeTab === "results" ? " app-tab--active" : ""}`}
              onClick={() => setActiveTab("results")}
            >
              {t.results}
              {resultCount > 0 && (
                <span className="app-tab-badge">{resultCount}</span>
              )}
            </button>
          </nav>
          <button className="lang-toggle" onClick={toggleLang} title="Switch language">
            {lang === "en" ? "ES" : "EN"}
          </button>
        </div>
      </header>
      <div className="app-body">
        <div className={`chat-col${activeTab !== "chat" ? " tab-hidden" : ""}`}>
          <ChatPanel
            onResult={handleResult}
            loading={loading}
            setLoading={setLoading}
            result={result}
          />
        </div>
        <div className={`results-col${activeTab !== "results" ? " tab-hidden" : ""}`}>
          <ResultsPanel result={result} />
        </div>
      </div>
    </div>
  );
}
